export enum RangeType {
  Span,
  PlusMinus,
}

export class Range {
  constructor(
    private type: RangeType,
    private left: number,
    private right: number
  ) {}
  public get min() {
    switch (this.type) {
      case RangeType.Span:
        return this.left;
      case RangeType.PlusMinus:
        return this.left - this.right;
      default:
        throw new Error("logical error");
    }
  }
  public get max() {
    switch (this.type) {
      case RangeType.Span:
        return this.right;
      case RangeType.PlusMinus:
        return this.left + this.right;
      default:
        throw new Error("logical error");
    }
  }
}
